var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltersCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50405 5.22112L7.8348 1.41455L4.50405 5.22112ZM12.1172 5.22112H4.50405H12.1172ZM4.50405 5.22112L7.8348 9.02769L4.50405 5.22112Z",
    fill: "#9872FE",
    stroke: "#9872FE",
    strokeWidth: 1.2326,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41211 1.17627V9.26522V1.17627Z",
    fill: "#9872FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41211 1.17627V9.26522",
    stroke: "#9872FE",
    strokeWidth: 1.2326,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersCollapse);
export default __webpack_public_path__ + "static/media/filters-collapse.88d937d3.svg";
export { ForwardRef as ReactComponent };